import { render, staticRenderFns } from "./StickyHScroll.vue?vue&type=template&id=f513e778&scoped=true"
import script from "./StickyHScroll.vue?vue&type=script&lang=ts"
export * from "./StickyHScroll.vue?vue&type=script&lang=ts"
import style0 from "./StickyHScroll.vue?vue&type=style&index=0&id=f513e778&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f513e778",
  null
  
)

export default component.exports